import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Dent = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.47 90.93">
  <G fill={color}>
   <Path d="M78.11,10.18c-3.75-5.09-9.91-10.18-20.09-10.18-6.04,0-10.52,2.03-14.32,4.63,1.15,1.17,2.26,2.27,3.29,3.13,5.44,4.51,10.07,4.99,11.81,4.99,1.83,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32c-2.46,0-8.95-.64-16.05-6.52-1.45-1.2-2.85-2.62-4.32-4.13C34.66,4.89,30.76.93,25.5.09c-.66-.05-1.34-.09-2.05-.09C13.27,0,7.11,5.09,3.36,10.18-.39,15.27.01,21.83.01,25.58s1.74,12.86,6.96,20.69c5.22,7.83,6.43,12.38,7.63,21.09,1.21,8.7,3.35,23.57,9.78,23.57s7.9-13.39,8.3-17.14c.4-3.75,1.87-17.14,8.05-17.14s7.64,13.39,8.05,17.14c.4,3.75,1.87,17.14,8.3,17.14s8.57-14.87,9.78-23.57c1.21-8.7,2.41-13.26,7.63-21.09,5.22-7.83,6.96-16.95,6.96-20.69s.4-10.31-3.35-15.4ZM23.45,16.72c-2.91,0-5.16,1.14-6.9,3.5-.98,1.33-.96,3.37-.95,4.86v.5c0,1.83-1.48,3.32-3.32,3.32s-3.32-1.49-3.32-3.32v-.45c-.02-2.01-.05-5.74,2.24-8.86,2.99-4.05,7.22-6.2,12.24-6.2,1.83,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32Z"/>
  </G>
</Svg>
);
};

export default Dent;
